module.exports = __webpack_public_path__ + "img/error.c42de43a.png";